import React, { useEffect } from 'react'
import useGlobalLoader from '../../hooks/useGlobalLoader'
import DOMPurify from 'dompurify'
import { useFlatPageQuery } from '@graphql/queries/__generated__/flatpage.generated'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogTitle from '@mui/material/DialogTitle'
import { DialogContent } from '@mui/material'
import MaybeRedirect from '@components/MaybeRedirect'
import { useLocation } from 'react-router'

interface IProps {
  url: string

  changePageTitle?(title: string): void

  variant?: 'dialog' | 'default'
}

const FlatPage: React.FC<IProps> = ({ url, changePageTitle, variant = 'default' }) => {
  const flatpageQuery = useFlatPageQuery({
    variables: { url: url },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  const { setLoading } = useGlobalLoader()
  const { pathname, search } = useLocation()

  useEffect(() => {
    setLoading(flatpageQuery.loading)
  }, [flatpageQuery.loading])

  useEffect(() => {
    if (changePageTitle) {
      changePageTitle(flatpageQuery.data?.flatpage?.title)
    }
  }, [flatpageQuery.data])

  if (flatpageQuery.loading) {
    return null
  }

  if (flatpageQuery.error || !flatpageQuery.data?.flatpage) {
    return <MaybeRedirect pathname={pathname} search={search} />
  }
  if (variant === 'dialog') {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(flatpageQuery.data.flatpage.content),
        }}
      />
    )
  }

  return (
    <div className='flatpage overflow-hidden'>
      <h1 className='text-xl sm:text-5xl text-center sm:text-left tracking-3/2 font-semibold uppercase mb-12'>
        {flatpageQuery.data.flatpage.title}
      </h1>
      <div
        className='content'
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(flatpageQuery.data.flatpage.content),
        }}
      />
    </div>
  )
}

export default React.memo(FlatPage)
